import {
  FireProtectionMaterial,
  FireResistance,
  FlamePreventionRegulation,
  Formaldehyde,
} from "@/web-client/api";

export const AllFireProtectionMaterials: FireProtectionMaterial[] = [
  FireProtectionMaterial.FIRE_PROTECTION_MATERIAL,
  FireProtectionMaterial.SEMI_COMBUSTIBLE,
  FireProtectionMaterial.RETARDANT,
];

export const AllFlamePreventionRegulations: FlamePreventionRegulation[] = [
  FlamePreventionRegulation.ANTI_INFLAMMATORY,
];

export const AllFormaldehydeLevels: Formaldehyde[] = [
  Formaldehyde.LEVEL_4,
  Formaldehyde.LEVEL_3,
  Formaldehyde.LEVEL_2,
];

export const AllFireRegistances: FireResistance[] = [
  FireResistance.FIRE_PROTECTION,
  FireResistance.THREE_QUARTERS_SEMI_FIREPROOF,
  FireResistance.HOUR_SEMI_FIREPROOF,
  FireResistance.HALF_HOUR_FIREPROOF,
  FireResistance.HOUR_FIREPROOF,
];
